<template>
    <tr>
        <td>
            {{item.id}}
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre del resort"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.name}}
            </span>
        </td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="deleteSubzone"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
        </td>
        
    </tr>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        suprazone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.item != null ? this.item.name : ''
            },
        }
    },
    async mounted() {
        
    },
    methods: {
        async editRow()  {
            this.edit = true
            
        },
        async saveChanges() {
            this.edit = false
            console.log('item', this.item)
            const data = {
                suprazone_id: this.item.pickup_zone.supra_zone,
                subzone_id: this.item.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('subzones/updateSubzone', data)
            this.$notify({
                group: "foo",
                title: "Resort editado",
                text: "Se ha editado la información del resort de recogida",
                type: "success",
            });
        },
        async deleteSubzone() {

            const data = {
                subzone_id: this.item.id,
            }
            this.$store.dispatch('subzones/deleteSubzone', data)
            .then( response => {
                this.$store.dispatch('subzones/getSubzonesGroupByPickupzone', {suprazone_id: this.item.pickup_zone.supra_zone})
                this.$notify({
                    group: "foo",
                    title: "El resort se ha eliminado",
                    text: "El resort " + this.item.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "El resort no se puede eliminar",
                    text: error.response.data.detail,
                    //text: "El resort " + this.item.name + " no se puede eliminar ya que tiene objetos vinculados (subzonas de recogida o puntos geográficos)",
                    type: "error",
                });
            })
        }
    },
    computed: {
    }
    
}
</script>